import { useContext, useEffect, useState } from 'react'
import ContentHeader from '../../../Layout/ContentHeader'
import { AuthContext } from '../../../../Auth/AuthContext'
import KpiCustomGraphicLine from '../ReportsCounters/components/KpiCustomGraphicLine'
import KpiCustomGraphicBar from '../ReportsCounters/components/KpiCustomGraphicBar'
import KpiMultiCards from '../ReportsCounters/components/KpiMultiCards'
import CategoryFilter from '../ReportsCounters/components/CategoryFilter'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { useMutation, useQuery } from '@apollo/client'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { GET_COUNTERS_WATER_TRUCK_REQUEST_FILTERS_OPTIONS, GET_REPORTS_COUNTERS_WATER_TRUCK_REQUEST } from '../../../../graphql/Document/ReportsCountersWaterTruckRequest/reportsCountersWaterTruckRequest'
import { handleError } from '@apollo/client/link/http/parseAndCheckHttpResponse'
import WaterTruckRequestPdfTemplate from './components/WaterTruckRequestPdfTemplate'
import Quill from 'react-quill'

const formatNumberWithCommas = (number) => {
  if (typeof number !== 'number') return number
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const ReportsCountersWaterTruckRequest = () => {
  //STATES
  const { user } = useContext(AuthContext)

  const MySwal = withReactContent(Swal)
  const dateType = [
    { value: 'ALL', label: 'General' },
    { value: 'YEAR', label: 'Ver por año' },
    { value: 'WEEK', label: 'Ver por semana' },
    { value: 'DAY', label: 'Ver por día' },
  ]

  const [pdfController, setPdfController] = useState({
    loading: false,
    hideElements: false,
    notes: null,
  })
  //STATES
  const [filters, setFilters] = useState({
    date_type: 'ALL',
    year: new Date().getFullYear().toString(),
    month: null,
    week: null,
  })

  const [options, setOptions] = useState({
    years: [],
    months: [],
    weeks: [],
  })
  const [counters, setCounters] = useState({
    generated: 0,
    resolved: 0,
    effectiveness: 0,
    counterByDateFilter: null,
    counterByDateFilterLines: null,
    counterByDateFilterLinesOptions: null,
  })

  //QUERIES AND MUTATIONS
  const {
    data: dataCounters,
    loading: loadingCounters,
    error: errorCounters,
  } = useQuery(GET_REPORTS_COUNTERS_WATER_TRUCK_REQUEST, {
    variables: {
      filters,
    },
    fetchPolicy: 'no-cache',
  })

  const [getFiltersOptions] = useMutation(
    GET_COUNTERS_WATER_TRUCK_REQUEST_FILTERS_OPTIONS
  )

  //EFFECTS
  useEffect(() => {
    if (!loadingCounters) {
      if (errorCounters) return handleError(errorCounters.message)
      if (dataCounters?.getReportsCountersWaterTruckRequest) {
        const dataFetch =
          dataCounters.getReportsCountersWaterTruckRequest

        let counterByDateFilter = null
        let counterByDateFilterLines = null
        let counterByDateFilterOptions = null
        let counterByDateFilterLinesOptions = null

        if (dataFetch?.counterByDateFilter) {
          counterByDateFilter = {
            labels: dataFetch?.counterByDateFilter.map(
              (item) => item.label.charAt(0).toUpperCase() + item.label.slice(1)
            ),
            datasets: [
              {
                label: 'Generados',
                data: dataFetch?.counterByDateFilter.map(
                  (item) => item.generated
                ),
                backgroundColor: '#F97316',
                borderColor: '#F97316',
                borderWidth: 1,
                maxBarThickness: 140,
                dataReports: dataFetch?.counterByDateFilter.map(
                  (item) => item.generated
                ),
              },
              {
                label: 'Resueltos',
                data: dataFetch?.counterByDateFilter.map(
                  (item) => item.resolved
                ),
                backgroundColor: '#9CA3AF',
                borderColor: '#9CA3AF',
                borderWidth: 1,
                maxBarThickness: 140,
                dataReports: dataFetch?.counterByDateFilter.map(
                  (item) => item.resolved
                ),
              },
            ],
          }

          counterByDateFilterLines = {
            labels: dataFetch?.counterByDateFilter.map(
              (item) => item.label.charAt(0).toUpperCase() + item.label.slice(1)
            ),
            datasets: [
              {
                label: 'Resueltos',
                data: dataFetch?.counterByDateFilter.map(
                  (item) => item.effectiveness
                ),
                borderColor: '#F97316',
                backgroundColor: '#F97316',
                tension: 0, // Suavizar las líneas
              },
            ],
          }
          counterByDateFilterOptions = {
            responsive: true,
            plugins: {
              legend: {
                display: true,
                position: 'top',
                labels: {
                  font: {
                    size: 15, // Aumentar el tamaño de los labels
                    weight: 'bold', // Hacer los labels en negrita
                  },
                  padding: 20,
                },
              },
              datalabels: {
                anchor: 'end',
                align: 'top',
                formatter: (value) => value,
                color: '#000',
                font: {
                  size: 15,
                  weight: 'bold',
                },
              },
            },
            scales: {
              y: {
                beginAtZero: true,
              },
              x: {
                ticks: {
                  color: '#4A4A4A', // Cambiar color de las etiquetas
                  font: {
                    size: 15, // Cambiar tamaño de fuente
                    weight: 'bold', // Cambiar peso de la fuente
                  },
                },
              },
            },
          }

          counterByDateFilterLinesOptions = {
            responsive: true,
            plugins: {
              legend: {
                display: true,
                position: 'top',
                labels: {
                  font: {
                    size: 15, // Aumentar el tamaño de los labels
                    weight: 'bold', // Hacer los labels en negrita
                  },
                },
              },
              datalabels: {
                anchor: 'end',
                align: 'top',
                formatter: function (value) {
                  return value.toFixed(2) + '%'
                },
                color: '#000',
                font: {
                  size: 15,
                  weight: 'bold',
                },
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    return `${context.dataset.label}: ${context.raw}%`
                  },
                },
              },
            },
            scales: {
              x: {
                offset: true,
                title: {
                  display: true,
                  text:
                    filters?.date_type === 'ALL'
                      ? 'Total'
                      : filters?.date_type === 'YEAR'
                      ? 'Anuales'
                      : filters?.date_type === 'MONTH'
                      ? 'Mensuales'
                      : filters?.date_type === 'WEEK'
                      ? 'Semanales'
                      : filters?.date_type === 'DAY'
                      ? 'Diarios'
                      : 'Total',
                },
                ticks: {
                  color: '#4A4A4A', // Cambiar color de las etiquetas
                  font: {
                    size: 15, // Cambiar tamaño de fuente
                    weight: 'bold', // Cambiar peso de la fuente
                  },
                },
              },
              y: {
                title: {
                  display: true,
                  text: '',
                },
                beginAtZero: true,
                ticks: {
                  // callback: function (value) {
                  //   return value.toFixed(2) // Asegurar dos decimales
                  // },
                },
              },
            },
          }
        }

        setCounters({
          generated: dataFetch?.generated,
          resolved: dataFetch?.resolved,
          effectiveness: dataFetch?.effectiveness,
          generalPercentage: dataFetch?.generalPercentage,
          counterByDateFilter,
          counterByDateFilterLines,
          counterByDateFilterOptions,
          counterByDateFilterLinesOptions,
        })
      }
    }
  }, [dataCounters, loadingCounters, errorCounters])

  //FUNCTIONS
  const handleChangeFilter = (selected) => {
    if (selected?.length === 0) {
      return setFilters({ ...filters, array_group_category_id: null })
    }
    setFilters({
      ...filters,
      array_group_category_id: selected.map((item) => item.value),
    })
  }

  const handleGeneratePdf = () => {
    //Add notes modal
    let modalMsdg = ''
    MySwal.fire({
      title: 'Exportar reporte',
      html: (
        <>
          <div className="message-container d-flex flex-column gap-3 mt-3">
            <div className="d-flex text-left gap-3" style={{ width: '100%' }}>
              <div className="input-container" style={{ width: '99%' }}>
                <label htmlFor="notes-editor" style={{ paddingLeft: '4px' }}>
                  Añadir alguna observación
                </label>
                <br />
                <Quill
                  id="notes-editor"
                  theme="snow"
                  onChange={(content) => {
                    modalMsdg = <div dangerouslySetInnerHTML={{ __html: content }} />
                  }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="btn btn-migrates mt-1 mr-3"
              onClick={() => document.querySelector('.swal2-confirm')?.click()}
            >
              Exportar reporte
            </button>
          </div>
        </>
      ),
      allowOutsideClick: true,
      buttonsStyling: false,
      showDenyButton: false,
      showConfirmButton: true,
      confirmButtonText: 'Exportar reporte',
      denyButtonText: 'Cancelar',
      customClass: {
        title: 'StandarModalTitleBackgroundNone',
        htmlContainer: 'StandarModalHtmlContainer standarModalAvoidFooter',
        confirmButton: 'btn btn-migrates d-none',
        footer: 'btn StandarModalFooterLogOut',
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          setPdfController({
            ...pdfController,
            notes: modalMsdg,
            loading: true,
            hideElements: true,
          })
          let timerInterval
          MySwal.fire({
            title: 'Generando PDF',
            html: 'Esto tomará un momento',
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading()
            },
            willClose: () => {
              clearInterval(timerInterval)
            },
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              setPdfController({
                ...pdfController,
                notes: null,
                loading: false,
                hideElements: false,
              })
            }
          })
        }
      })
      .catch((error) => {})
  }

  const handleChangeYear = async (e) => {
    if (filters.date_type === 'YEAR') {
      setFilters((prev) => ({
        ...prev,
        year: e.value,
      }))
      return
    }
    //Fetch options for months and weeks based on the selected year
    try {
      const { data } = await getFiltersOptions({
        variables: {
          filters: {
            date_type: filters.date_type,
            year: e.value,
          },
        },
      })
      if (filters.date_type === 'WEEK') {
        setOptions((prev) => ({
          ...prev,
          months: data?.getCountersWaterTruckRequestFiltersOptions?.months,
          weeks: [],
        }))
        setFilters((prev) => ({
          ...prev,
          year: e.value,
          month:
            data?.getCountersWaterTruckRequestFiltersOptions?.months.slice(-1)[0]
              ?.value,
          week: null,
        }))
      } else if (filters.date_type === 'DAY') {
        setOptions((prev) => ({
          ...prev,
          year: e.value,
          weeks: data?.getCountersWaterTruckRequestFiltersOptions?.weeks,
          months: [],
        }))
        setFilters((prev) => ({
          ...prev,
          year: e.value,
          month: null,
          week: data?.getCountersWaterTruckRequestFiltersOptions?.weeks.slice(-1)[0]
            ?.value,
        }))
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleOnChangeDateType = async (value) => {
    try {
      const { data } = await getFiltersOptions({
        variables: {
          filters: {
            date_type: value,
            year: filters.year,
          },
        },
      })
      if (value === 'YEAR') {
        setOptions((prev) => ({
          ...prev,
          years: data?.getCountersWaterTruckRequestFiltersOptions?.years,
          months: [],
          weeks: [],
        }))
        setFilters((prev) => ({
          ...prev,
          date_type: value,
          year: data?.getCountersWaterTruckRequestFiltersOptions?.years[0],
          month: null,
          week: null,
        }))
      } else if (value === 'WEEK') {
        setOptions((prev) => ({
          ...prev,
          years: data?.getCountersWaterTruckRequestFiltersOptions?.years,
          months: data?.getCountersWaterTruckRequestFiltersOptions?.months,
          weeks: [],
        }))
        setFilters((prev) => ({
          ...prev,
          date_type: value,
          year: data?.getCountersWaterTruckRequestFiltersOptions?.years[0],
          month:
            data?.getCountersWaterTruckRequestFiltersOptions?.months.slice(-1)[0]
              ?.value,
          week: null,
        }))
      } else if (value === 'DAY') {
        setOptions((prev) => ({
          ...prev,
          years: data?.getCountersWaterTruckRequestFiltersOptions?.years,
          weeks: data?.getCountersWaterTruckRequestFiltersOptions?.weeks,
          months: [],
        }))
        setFilters((prev) => ({
          ...prev,
          date_type: value,
          year: data?.getCountersWaterTruckRequestFiltersOptions?.years.slice(-1)[0],
          month: null,
          week: data?.getCountersWaterTruckRequestFiltersOptions?.weeks.slice(-1)[0]
            ?.value,
        }))
      } else {
        setOptions((prev) => ({
          ...prev,
          years: [],
          weeks: [],
          months: [],
        }))
        setFilters((prev) => ({
          ...prev,
          date_type: value,
          year: new Date().getFullYear().toString(),
          month: null,
          week: null,
        }))
      }
      return
    } catch (error) {
      console.error('Error fetching options:', error)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <h1 className="header-title">
            Bienvenido{user.name ? `, ${user.name}` : ''}
          </h1>
        }
        breadcrumb=""
        windowTitle="Dashboard"
      />

      {pdfController.hideElements ? (
        <div>
          <WaterTruckRequestPdfTemplate
            filters={filters}
            pdfController={pdfController}
            counters={counters}
            options={options}
          />
        </div>
      ) : (
        <div className={`row px-3 py-3 reports-counters-water-truck-request`}>
          {/**Header */}
          <div className="col-12 header-box">
            <span className="text-center">
              Aquí tienes un resumen de lo que está pasando el día de hoy.
            </span>
            <button className='btn btn-purple' onClick={handleGeneratePdf}>Descargar reporte</button>
          </div>

          {/**Filters */}
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 filters-box">
            <div className="row mb-4">
              <CategoryFilter
                titleContent={<label>Ver por{` `}</label>}
                placeholder="Todos los reportes"
                options={dateType}
                onChange={(e) => {
                  handleOnChangeDateType(e.value)
                }}
                showValue={true}
                value={dateType.find(
                  (item) => item.value === filters.date_type
                )}
                isMulti={false}
              />
            </div>
            {(filters.date_type === 'YEAR' ||
              filters.date_type === 'WEEK' ||
              filters.date_type === 'DAY') && (
              <div className="row mb-4">
                <CategoryFilter
                  titleContent={<label>Año</label>}
                  placeholder="Selecciona un año"
                  options={options.years.map((year) => ({
                    value: year,
                    label: year,
                  }))}
                  onChange={(e) => handleChangeYear(e)}
                  showValue={true}
                  value={{ value: filters.year, label: filters.year }}
                  isMulti={false}
                />
              </div>
            )}
            {filters.date_type === 'WEEK' && (
              <>
                <div className="row mb-4">
                  <CategoryFilter
                    titleContent={<label>Mes</label>}
                    placeholder="Selecciona un mes"
                    options={options.months}
                    onChange={(e) => setFilters({ ...filters, month: e.value })}
                    showValue={true}
                    value={options.months.find(
                      (item) => item.value === filters.month
                    )}
                    isMulti={false}
                  />
                </div>
              </>
            )}
            {filters.date_type === 'DAY' && (
              <>
                <div className="row mb-4">
                  <CategoryFilter
                    titleContent={<label>Semana</label>}
                    placeholder="Selecciona una semana"
                    options={options.weeks}
                    onChange={(e) => setFilters({ ...filters, week: e.value })}
                    showValue={true}
                    value={options.weeks.find(
                      (item) => item.value === filters.week
                    )}
                    isMulti={false}
                  />
                </div>
              </>
            )}
          </div>

          {/** Data and Graphics */}
          <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
            {/**Counters */}
            <div className="row">
              <div
                className={`col-12 cards-box`}
              >
                <KpiMultiCards
                  cards={[
                    {
                      title: 'Sistema de indicadores',
                      value: `${
                        counters?.generalPercentage
                          ? counters?.generalPercentage >= 80
                            ? 'Bueno'
                            : counters?.generalPercentage >= 60
                            ? 'Normal'
                            : 'Regular'
                          : 'Regular'
                      }`,
                      iconContent: <i className="fas fa-check colorGreen" />,
                    },
                    {
                      title: 'Porcentaje general',
                      value: `${counters?.generalPercentage || 0}%`,
                      iconContent: <i className="fas fa-check colorGreen" />,
                    },
                  ]}
                />
              </div>
            </div>
            {/**Graphics */}
            <div className="row graphics-box-container counters-page-break">
              {counters?.counterByDateFilter && (
                <div className="graphics-box col-12">
                  <div className="header">
                    <h5 className="text-left">
                      Reportes{' '}
                      {filters?.date_type === 'ALL'
                        ? 'generales'
                        : filters?.date_type === 'YEAR'
                        ? 'anuales'
                        : filters?.date_type === 'MONTH'
                        ? 'mensuales'
                        : filters?.date_type === 'WEEK'
                        ? 'semanales'
                        : filters?.date_type === 'DAY'
                        ? 'diarios'
                        : 'generales'}
                    </h5>
                  </div>

                  <div className="body">
                    <div className={`legend`}>
                      <div className="legend-item mr-3">
                        <h5>Generados</h5>
                        <p>{formatNumberWithCommas(counters?.generated)}</p>
                      </div>
                      <div className="legend-item mr-3">
                        <h5>Resueltos</h5>
                        <p>{formatNumberWithCommas(counters?.resolved)}</p>
                      </div>
                      <div className="legend-item">
                        <h5>Efectividad</h5>
                        <p>{counters?.effectiveness}%</p>
                      </div>
                    </div>
                    <div className="chart">
                      <KpiCustomGraphicBar
                        barDataStatus={counters?.counterByDateFilter}
                        barOptions={counters?.counterByDateFilterOptions}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="graphics-box col-12 mt-3">
                <div className="header">
                  <h5 className="text-left">
                    % de resueltos{' '}
                    {filters?.date_type === 'ALL'
                      ? 'total'
                      : filters?.date_type === 'YEAR'
                      ? 'anuales'
                      : filters?.date_type === 'MONTH'
                      ? 'mensuales'
                      : filters?.date_type === 'WEEK'
                      ? 'semanales'
                      : filters?.date_type === 'DAY'
                      ? 'diarios'
                      : 'total'}
                  </h5>
                </div>
                <div className="body">
                  <div className="chart">
                    <KpiCustomGraphicLine
                      lineData={counters?.counterByDateFilterLines}
                      lineOptions={counters?.counterByDateFilterLinesOptions}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ReportsCountersWaterTruckRequest
